// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import axios from 'axios'
import ElementUI from 'element-ui'


// 自定义公共组件
import pageBody from '@/components/content-body'
import innerArea from '@/components/inner-area'
import messageList from '@/components/message-list'
import messageItem from '@/components/message-item'
import modal from '@/components/modal'
import loading from '@/components/loading'

import 'element-ui/lib/theme-chalk/index.css'

import '~/css/reset.css'
import '~/css/base.css'
import '@/assets/css/jdy.css'
import { UseAxios, merge } from './common/index'
import IdentityService from '@/service/identity';

Vue.use(ElementUI)

// 富文本
import VueQuillEditor from 'vue-quill-editor'
Vue.use(VueQuillEditor)

UseAxios(router)

axios.defaults.withCredentials = true

merge(Vue.prototype, {
  $http: axios,
  $identity: new IdentityService(axios),
  router: router
})

Vue.config.productionTip = false

const components = [
  pageBody,
  innerArea,
  messageList,
  messageItem,
  modal,
  loading
];

components.map(component => {
  Vue.component(component.name, component)
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: {
    App
  },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js